export default "__VITE_ASSET__DUxjYP8U__"